import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/Motion";
import BookingDialog from "@/components/BookingDialog";
import Seo from "@/components/Seo";
import api from "@/lib/api";

const CATS = ["Consulti Individuali", "Trattamenti Energetici", "Formazione Lux Academy", "Percorsi Biblici"];

export default function Servizi() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-32 pb-28 constellation min-h-screen">
      <Seo title="Servizi — Consulti, Trattamenti e Formazione" description="Lettura dei Registri Akashici, channeling, medianità, pranoterapia, cristalloterapia, trattamenti angelici, percorsi biblici e formazione Lux Academy. Prenotazione immediata online o in presenza."
        jsonLd={{ "@context": "https://schema.org", "@type": "ItemList", itemListElement: services.map((s, i) => ({ "@type": "ListItem", position: i + 1, name: s.title, url: `${process.env.REACT_APP_BACKEND_URL}/servizi/${s.slug}` })) }} />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">I servizi</p>
          <h1 className="font-display text-5xl sm:text-7xl text-[#2A1F14] leading-[1.02] max-w-3xl mb-8">Consulti, trattamenti e formazione.</h1>
          <p className="text-[#2A1F14]/55 text-lg max-w-2xl leading-relaxed">Ogni servizio è un accompagnamento su misura, con descrizione, durata, investimento e prenotazione immediata.</p>
        </Reveal>

        {CATS.map((cat, ci) => {
          const list = services.filter((s) => s.category === cat);
          if (!list.length) return null;
          return (
            <section key={cat} className="mt-20" data-testid={`cat-${ci}`}>
              <div className="flex items-center gap-4 mb-10">
                <span className="font-display text-2xl sm:text-3xl text-gold">{cat}</span>
                <div className="flex-1 h-px bg-[#2A1F14]/10" />
              </div>
              <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {list.map((s) => (
                  <StaggerItem key={s.slug}>
                    <div className="group border border-[#2A1F14]/10 rounded-2xl overflow-hidden h-full flex flex-col hover:border-gold/40 transition-colors duration-500" data-testid={`service-${s.slug}`}>
                      <Link to={`/servizi/${s.slug}`} className="block relative aspect-[16/10] overflow-hidden">
                        <img src={s.image} alt={s.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" loading="lazy" />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#F7EFE0] to-transparent" />
                      </Link>
                      <div className="p-6 flex flex-col flex-1">
                        <Link to={`/servizi/${s.slug}`}><h3 className="font-display text-2xl text-[#2A1F14] mb-2 group-hover:text-gold transition-colors">{s.title}</h3></Link>
                        <p className="text-[#2A1F14]/45 text-sm leading-relaxed mb-5 flex-1">{s.subtitle || s.description?.slice(0, 90)}</p>
                        <div className="flex items-center justify-between text-sm mb-5">
                          <span className="inline-flex items-center gap-1.5 text-[#2A1F14]/50"><Clock size={14} className="text-gold" />{s.duration}</span>
                          <span className="text-gold font-display text-lg">{s.price}</span>
                        </div>
                        <div className="flex gap-3">
                          <BookingDialog title={`Prenota — ${s.title}`}
                            presets={{ type: s.category === "Formazione Lux Academy" ? "corso" : "servizio", service: s.title }}
                            endpoint={s.category === "Formazione Lux Academy" ? "enrollments" : "bookings"}
                            trigger={<button data-testid={`book-${s.slug}`} className="flex-1 py-2.5 rounded-full bg-gold text-black text-sm font-medium hover:bg-[#D4A056] transition-colors">Prenota</button>} />
                          <Link to={`/servizi/${s.slug}`} className="px-4 py-2.5 rounded-full border border-[#2A1F14]/15 text-[#2A1F14]/70 text-sm hover:border-gold hover:text-gold transition-colors inline-flex items-center"><ArrowRight size={16} /></Link>
                        </div>
                      </div>
                    </div>
                  </StaggerItem>
                ))}
              </Stagger>
            </section>
          );
        })}
      </div>
    </div>
  );
}
